import { Presentation } from 'lucide-react'
import { SiteLayout } from '../components/ui/site-chrome'
import { TrustPage } from '../components/ui/trust-page'

export default function WorkshopsPage() {
  return (
    <SiteLayout
      current="/workshops"
      title="AI Workshops & Founder Labs | Zadro"
      description="Hands-on AI workshops for companies, founders, and city cohorts that want to build practical AI systems, agents, and prototypes."
    >
      <TrustPage
        Icon={Presentation}
        visual="workshops"
        eyebrow="Workshops"
        heroTitle="AI workshops that end with working systems, not just slides."
        heroCopy="Workshops are designed for founders, operators, and teams who need practical fluency. The goal is to leave with mental models, templates, prototypes, and a sharper sense of what to build next."
        proof={[
          'Private team workshops and public city cohorts.',
          'Hands-on labs covering AI tools, LLM providers, schemas, workflows, and prototypes.',
          'Premium workshops for canonical contextual agents and product-grade AI architecture.',
        ]}
        cards={[
          {
            title: 'AI Operator Workshop',
            copy: 'A practical session for startup and mid-market teams learning how to use AI across workflows without drowning in hype.',
          },
          {
            title: 'Build With AI Sprint',
            copy: 'A fast-paced cohort that moves from database schema and product idea to UI, backend behavior, and working prototype.',
          },
          {
            title: 'Canonical Agents Lab',
            copy: 'An advanced workshop on user systems, context blocks, agent schemas, orchestration, memory, and production patterns.',
          },
        ]}
        sections={[
          {
            kicker: 'Audience',
            title: 'Built for people who need to make decisions.',
            copy: 'The workshops are not generic AI awareness sessions. They are for teams and founders who need to choose tools, ship workflows, and avoid expensive mistakes.',
            items: [
              'Non-technical founders learning how to lead technical work',
              'Operators who need to turn AI interest into workflow improvement',
              'Product and engineering teams exploring agentic systems',
              'Companies that want a shared language before committing budget',
            ],
          },
          {
            kicker: 'Format',
            title: 'Small cohorts, real exercises, reusable artifacts.',
            copy: 'Each format can be adapted for a company, a city cohort, or a premium advanced lab.',
            items: [
              '90-minute executive workshop',
              'Half-day or full-day team intensive',
              'Four-session implementation cohort',
              'VIP seat with office hours, architecture review, or product coaching',
            ],
          },
        ]}
      />
    </SiteLayout>
  )
}
